import { Component, Prop, Ref, SimpleEvent, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class InPageNavigation extends ThemeComponent {
    @Prop({ default: false }) sticky!: boolean;
    @Ref() navigationItems!: HTMLUListElement[];

    init() {

        for (const navigationItem of this.navigationItems) {
            const sectionId = navigationItem.dataset.section;

            if (sectionId === null) {
                this.$log.error('data-section attribute does not exist');
            }

            if (sectionId === '') {
                this.$log.error('data-section value blank');

            }

            if (document.getElementById(`${sectionId}`) === null) {
                this.$log.error(`Section ${sectionId} not found`);
            }
        }

        if (this.sticky) {
            this.stickyEvent();
        }

        this.scrollEvents();
    }

    stickyEvent() {

        const parent = this.closest('.shopify-section');

        if (parent) {
            parent.classList.add('sticky');
        } else {
            this.classList.add('sticky');
        }
    }

    scrollEvents() {
        for (const navigationItem of this.navigationItems) {
            this.$listen(navigationItem, 'click', () => {
                const sectionId = navigationItem.dataset.section;
                if (sectionId && sectionId != '') {
                    document.getElementById(`${sectionId}`)?.scrollIntoView();
                }
            });
        }
    }
}
